import axios from 'axios';
import qs from 'qs';
import {
    Message
} from 'element-ui'
axios.defaults.timeout = 500000000000;
axios.defaults.baseURL = 'https://admin.w.zxhphp.com'; //本地
// axios.defaults.baseURL = '/out-api'; //线上
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    config => {
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.headers['Authorization'] = 'Bearer ' + (sessionStorage.getItem("USER-TOKEN") || '');
        if (sessionStorage.getItem("SYSTEM-TOKEN")) {
            config.headers['System-Code'] = sessionStorage.getItem("SYSTEM-TOKEN");
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);


//http response 拦截器
axios.interceptors.response.use(response => {
    if (response.data.code != 0) {
        if (response.data.code == 401) {
            Message.error(response.data.msg);
            if(localStorage.getItem('g') ==1){
                window.location = "/#/AdminLogin";
            }else{
                window.location = "/#/login";
            }
            return Promise.reject(response.data.msg);
        } else {
            Message.error(response.data.msg);
            return Promise.reject(response.data.msg);
        }
    } else {
        return response.data;
    }
}, error => {
    if (error.status == 401) {
        Message.error(error.response.data.msg);
        if(localStorage.getItem('g') ==1){
            window.location = "/#/AdminLogin";
        }else{
            window.location = "/#/login";
        }
    } else {
        Message.error(error.response.data.msg);
    }
    return Promise.reject(error);
});

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(response => {
            resolve(response);
        }, err => {
            reject(err);
        });
    });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            data: params, 
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url,params).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err);
        });
    });
}